import React, { useState } from 'react';
import { Alert, Button, Modal, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { SurveyExportPackage } from '../../../types/survey-copy';
import { surveyCopyService } from '../../../services/survey-copy.service';

interface SurveyImportDialogProps {
  onImported?: () => void;
}

export const SurveyImportDialog: React.FC<SurveyImportDialogProps> = ({ onImported }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState<SurveyExportPackage | null>(null);
  const [error, setError] = useState<string | null>(null);

  const beforeUpload = async (file: File) => {
    try {
      const text = await file.text();
      const parsed = JSON.parse(text) as SurveyExportPackage;
      setPayload(parsed);
      setError(null);
      message.success('Arquivo carregado com sucesso');
    } catch {
      setPayload(null);
      setError('Arquivo inválido: JSON malformado');
    }

    return false;
  };

  const handleImport = async () => {
    if (!payload) {
      setError('Selecione um JSON de exportação válido.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const result = await surveyCopyService.importSurvey(payload);
      message.success(`Pesquisa importada em rascunho: ${result.title}`);
      setOpen(false);
      setPayload(null);
      onImported?.();
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || 'Falha ao importar pesquisa';
      const fieldErrors = err?.response?.data?.details?.errors;
      if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
        const formatted = fieldErrors.map((item: any) => `${item.path}: ${item.message}`).join(' | ');
        setError(formatted);
      } else {
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button icon={<UploadOutlined />} onClick={() => setOpen(true)}>
        Importar JSON
      </Button>

      <Modal
        title="Importar pesquisa"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleImport}
        confirmLoading={loading}
        okText="Importar"
      >
        {error && <Alert type="error" message={error} style={{ marginBottom: 12 }} />}

        <Upload beforeUpload={beforeUpload} maxCount={1} accept="application/json,.json" showUploadList>
          <Button icon={<UploadOutlined />}>Selecionar JSON</Button>
        </Upload>
      </Modal>
    </>
  );
};
